import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { MyPageHead } from "../common/index";
import PostRender from "../../community/main/PostRender/index";
import MyCommentsRender from "./MyCommentsRender/index";

import { loadMyFeed } from "redux/modules/userFeedSlice";
import { loadPost } from "redux/modules/postSlice";

import { MypageWrapper } from "../common/style";
import { MyFeedToggle, MyComments } from "./FeedStyle";

function Feed() {
  const dispatch = useDispatch();
  const [boards, setBoards] = useState("selected");
  const [comments, setComments] = useState("");

  useEffect(() => {
    // const payload = { category: "전체", page: 1 };
    // dispatch(loadPost(payload));
    dispatch(loadMyFeed());
  }, [dispatch]);

  //const mainPosts = useSelector((state) => state.post.mainPosts);
  const myPosts = useSelector((state) => state.myPage.myPosts);
  const myComments = useSelector((state) => state.myPage.myComments);
  const currentMyComments =
    myComments.length > 0 &&
    myComments.filter((comment) => comment.isDeleted === "false");
  // const currentMyPosts =
  //   myPosts.length > 0 &&
  //   myPosts
  //     .map((post) => mainPosts.filter((v) => v.boardId === post.boardId)[0])
  //     .filter((v) => v !== undefined);
  const currentMyPosts = myPosts;

  // 게시글/댓글 탭 클릭
  const onClickBoards = useCallback(() => {
    setBoards("selected");
    setComments("");
    dispatch(loadMyFeed());
  }, [dispatch]);

  const onClickComments = useCallback(() => {
    setComments("selected");
    setBoards("");
    dispatch(loadMyFeed());
  }, [dispatch]);

  return (
    <MypageWrapper>
      <MyPageHead title="내가 쓴 글" />

      <MyFeedToggle>
        <div className={boards} onClick={onClickBoards}>
          게시글
        </div>
        <div className={comments} onClick={onClickComments}>
          댓글
        </div>
      </MyFeedToggle>

      {/* 게시글 탭 */}
      {boards === "selected" &&
        currentMyPosts.length > 0 &&
        currentMyPosts.map((post) => (
          <PostRender key={post.boardId} post={post} />
        ))}

      {/* 댓글 탭 */}
      {comments === "selected" && (
        <MyComments>
          {currentMyComments.length > 0 &&
            currentMyComments.map((comment) => (
              <MyCommentsRender comment={comment} />
            ))}
        </MyComments>
      )}
    </MypageWrapper>
  );
}

export default Feed;
